(function () {
  var header = document.getElementById('header');
  if (header) {
    var headerHeight = header ? header.offsetHeight : 0;
    document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
  }
  var footer = document.getElementById('footer');
  if (footer) {
    var footerHeight = footer.offsetHeight;
    document.documentElement.style.setProperty('--footer-height', footerHeight + 'px');
  }
})();
